/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { createAction, props } from '@ngrx/store';
import { ISystemInfo } from './system-info.state';

const SYSTEM_INFO_SOURCE = '[System Info]';

/**
 * Force load system info data, regarless of data freshness max age.
 */
export const loadSystemInfo = createAction(
    `${SYSTEM_INFO_SOURCE} Load System Info`,
);

/**
 * Load system info data, complying with a cache freshness period, within which reload is not
 * allowed. If allowing loading, a "loadSystemInfo" is dispatched (see its effect).
 */
export const passiveLoadSystemInfo = createAction(
    `${SYSTEM_INFO_SOURCE} Passive Load System Info`,
);

export const systemInfoLoadSuccess = createAction(
    `${SYSTEM_INFO_SOURCE} System Info Load Success`,
    props<{ systemInfo: ISystemInfo }>(),
);

export const systemInfoLoadFailure = createAction(
    `${SYSTEM_INFO_SOURCE} System Info Load Failure`,
    props<{ error: any }>(),
);

export const setAllowReload = createAction(
    `${SYSTEM_INFO_SOURCE} Set Allow Reload System Info`,
    props<{ allowReload: boolean }>(),
);

/**
 * Cancel in-progress loading. The "loaded" state before the loading call will be kept.
 */
export const cancelLoading = createAction(
    `${SYSTEM_INFO_SOURCE} Cancel Loading System Info`,
);

export const clearLoadingError = createAction(
    `${SYSTEM_INFO_SOURCE} Clear System Info Loading Error`,
);
